import React, { useState } from "react";
import { Modal, Button } from "antd";
import styled from "@emotion/styled";
import { EnvironmentOutlined } from "@ant-design/icons";
import COLORS from "common/Colors";
import LocationMapPicker from "molecules/LocationMapPicker";

const TriggerIcon = styled(EnvironmentOutlined)`
  color: ${(props) => (props.disabled ? "#c0c0c9" : COLORS.BLUE)};
  font-size: 16px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover {
    color: ${(props) => (props.disabled ? "#c0c0c9" : "#1a85e0")};
  }
`;

// Small map-pin trigger placed next to a field; opens the map picker in a
// modal. Picking a spot on the map only stages it locally — it's applied to
// the caller's form (via onLocationChange) only when the user confirms with
// "Use Location"; "Cancel" (or the X icon / clicking outside) discards it.
const LocationMapPickerModal = ({
  lat,
  lng,
  countryOptions,
  onLocationChange,
  disabled,
  autoLocate,
}) => {
  const [open, setOpen] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);

  const handleOpen = () => {
    if (disabled) return;
    setPendingLocation(null);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  // Stage the picked/searched/auto-located spot without applying it to the
  // caller's form yet.
  const handleLocationChange = (location) => {
    setPendingLocation(location);
  };

  const handleUseLocation = () => {
    if (!pendingLocation) return;
    onLocationChange(pendingLocation);
    handleClose();
  };

  return (
    <>
      <TriggerIcon
        onClick={handleOpen}
        disabled={disabled}
        title="Pick location on map"
      />
      <Modal
        title="Select Location on Map"
        visible={open}
        onCancel={handleClose}
        destroyOnClose
        width={640}
        footer={[
          <Button key="cancel" onClick={handleClose}>
            Cancel
          </Button>,
          <Button
            key="use"
            type="primary"
            disabled={!pendingLocation}
            onClick={handleUseLocation}
          >
            Use Location
          </Button>,
        ]}
      >
        <LocationMapPicker
          lat={lat}
          lng={lng}
          countryOptions={countryOptions}
          autoLocate={autoLocate}
          onLocationChange={handleLocationChange}
        />
      </Modal>
    </>
  );
};

export default LocationMapPickerModal;
